<div
  class="hall-item-container"
  [class]="'trophy-type-' + trophy()">
  <img
    [src]="trophyImage()"
    class="trophy-img"
    [class.disabled-trophy]="isDisabled()"
    alt="Trophy" />

  <div
    class="ribbon-container"
    [class.disabled]="isDisabled()">
    <img
      [src]="ribbonImage()"
      class="ribbon-img"
      alt="Ribbon" />
    <div class="trophy-amount">x{{ total() }}</div>
  </div>
</div>
